import { render } from "./MagentoSecurityServices.vue?vue&type=template&id=b69fcfb4"
import script from "./MagentoSecurityServices.vue?vue&type=script&lang=js"
export * from "./MagentoSecurityServices.vue?vue&type=script&lang=js"

import "./MagentoSecurityServices.vue?vue&type=style&index=0&id=b69fcfb4&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__